import { InputHTMLAttributes, forwardRef } from 'react'

import { styled, css } from 'styled-components'

import { Label } from 'peach/components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 100%;
`

const focused = css`
  border-color: ${(p) => p.theme.highlight};
  box-shadow: none;
`
export const StyledInput = styled.input<{ isFocused?: boolean }>`
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  padding: 8px 12px;
  width: ${(p) => p.width};
  color: ${(p) => p.theme.text};

  &:disabled {
    border-color: ${(p) => p.theme.border};
    background-color: ${(p) => p.theme.offset};
    color: #888;
  }

  ${(p) => p.isFocused && focused}

  &:focus {
    ${focused}
  }
`

export type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  className?: string
  label?: string
}

const Input = forwardRef<HTMLInputElement, TextInputProps>(
  ({ onChange, prefix, width, disabled, className, label, ...props }, ref) => (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <StyledInput
        className={className}
        width={width}
        ref={ref}
        onChange={(e) => {
          onChange?.(e)
        }}
        disabled={disabled}
        {...props}
      />
    </Wrapper>
  ),
)

export default Input
